<template>
  <delivery-options :deliveryOptions="deliveryOptions" />
</template>

<script>
import { mapGetters } from 'vuex';
import DeliveryOptions from './DeliveryOptions';

export default {
  components: { DeliveryOptions },
  computed: {
    ...mapGetters(['deliveryOptions']),
  },
};
</script>
